import utils, {getValueFromJSON, setValueInJSON} from "../js/utils";
import form_validator     from "../js/form_validators";
let assert = require('assert');

const flat_object = (obj, path, result = {}, ignoreFieldsList = []) => {
    Object.keys(obj).forEach(key =>{
        if (obj[key] instanceof Object && !ignoreFieldsList.includes(key)){
            result = Object.assign(result, flat_object(obj[key], [path, key].filter(item => item).join(".")), result, ignoreFieldsList)
        }
        else {
            result[[path, key].filter(item => item).join(".")] = obj[key];
        }
    });
    return result
};

const get_changed_values = (new_data, old_data, ignoreFieldsList) => {
    let data = Object.keys(new_data).reduce((res, key) => {
        let new_value = new_data[key];
        let old_value = getValueFromJSON(old_data, key);
        if ((ignoreFieldsList || []).includes(key)) {
            setValueInJSON(res, key, new_value)
        }
        else {
            if (new_value instanceof Object) {
                try {
                    assert.deepStrictEqual(new_value, old_value)
                }catch(e){
                    setValueInJSON(res, key, new_value)
                }
            }
            else if ((new_value || new_value === false || new_value === 0 || new_value === "") && new_value !== old_value)
                setValueInJSON(res, key, new_value)
        }

        return res;
    }, {});

    return Object.keys(data).length ? data : null
};

const get_form_value = async (form) => {
    let form_data = await form_validator.value_extractor(form);
    if (!form_data)
        return null;

    let data = Object.keys(form_data).reduce((res, key) => {
        if (form_data.hasOwnProperty(key)) {
            utils.setValueInJSON(res, key, form_data[key])
        }

        return res;
    }, {});

    if (data.date_range) {
        if (data.date_range[0]?._d)
            data.from_date =  data.date_range[0]._d.toISOString();
        if (data.date_range[1]?._d)
            data.to_date =  data.date_range[1]._d.toISOString();
        delete data.date_range
    }


    return Object.keys(data).length ? data : null
};

const modules = {
    flat_object,
    get_changed_values,
    get_form_value
}

export default modules
